import { Getters } from 'vuex-smart-module';
import PartnerCompanyState from './state';

export default class PartnerCompanyGetters extends Getters<PartnerCompanyState> {}
